import React, { useEffect, useState } from 'react';
import { FaUser, FaClock, FaPrescription } from 'react-icons/fa';
import flattenHistory from './flattenHistory';
import { use } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import paths from 'routes/paths';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';
import { Alert } from 'react-bootstrap';
// import './Timeline.css'; // Optional custom styles

const PatientHistory = () => {
  const [historyObj, setHistoryObj] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    fetchData();
  }, [])

  const fetchData = async () => {
    setLoading(true);
    let tokenString = localStorage.getItem("accessToken");
    try {
      let response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/patients/patient-history`,
        { patient_id: localStorage.getItem("patientId") },
        { headers: { Authorization: `Bearer ${tokenString}` } }
      );
      if(response.data.status) {
        let dataObj = response.data.historyObj
        setHistoryObj(dataObj);
      }else{
        setError(true);
      }
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
    // const entries = flattenHistory(dataObj);

    // const groupedByDate = entries.reduce((acc, entry) => {
    //     acc[entry.date] = acc[entry.date] || [];
    //     acc[entry.date].push(entry);
    //     return acc;
    // }, {});
    // console.log(dataObj)
  }


  // decalre object to replace col_changed with a string
  const colChangedMap = {
    "doctor_id": "Doctor",
    "drug": "Drug",
    "dosage": "Dosage",
    "route": "Route",
    "frequency_id": "Frequency",
    "start_date": "Start Date",
    "end_date": "End Date",
    "client_stopdate": "Stop Date",
    "has_vitalsigns": "Has Vital Signs",
    "prescriber": "Prescriber",
    "notes": "Notes",
    "reason_id": "Reason",
    "route_id": "Route",
    "special_instruction_id": "Special Instruction",
    "early": "Early",
    "time_between_meds": "Time Between Meds",
    "verified_date": "Verified Date",
    "medication_independent_status": "Medication Independent Status",
    "medgroup_id": "Med Group",
    "drugunit_id": "Drug Unit",
    "not_exceed": "Not To Exceed",
    "tar_flag": "Treatment Flag",
    "remarks": "Call HCP Remarks",
    "time_1": "Time 1",
    "time_2": "Time 2",
    "time_3": "Time 3",
    "time_4": "Time 4",
    "time_5": "Time 5",
    "time_6": "Time 6",
    "time_7": "Time 7",
    "time_8": "Time 8",

    // Add more mappings as needed
  };

  return (
    <div className="timeline">
      {loading ? (<ShimmerUI/>) : (!error) ? (Object.entries(historyObj).map(([date, logs]) => (
        <div key={date} className="timeline-date-group">
          <div className="timeline-date">{new Date(date).toDateString()}</div>

          {Object.entries(logs).map(([time, dataType]) => {
            const prescriptions = dataType.prescription || {};
            return (
              // check if dataType is an object and has a prescription property
              Object.entries(prescriptions).map(([_, prescription]) => {
                const { drug, history } = prescription;
                // output a div
                return (
                  <div className="timeline-item" key={prescription.prescription_id}>
                    <div className="timeline-icon my-2 mr-2"><FaPrescription /></div>
                    <div className="timeline-content">
                      <Link to={{ pathname: `${paths.editPrescription}/${prescription.id}` }}>
                        <div className="timeline-title">{drug}</div>
                      </Link>
                      {history.map(item => {
                        return (
                          <div key={item.id} className="timeline-desc">
                            <span className="text-bold">{colChangedMap[item.col_changed] ? colChangedMap[item.col_changed] : item.col_changed}</span>
                            {item.old_value !== null && item.old_value !== undefined && item.old_value !== "" ? (
                              <span> changed from <em>{item.old_value}</em> to <em>{item.new_value}</em></span>
                            ) : (
                              <span> has been set to {item.new_value}</span>
                            )}
                            {/* {item.col_changed} changed from {item.old_value} to {item.new_value} */}
                          </div>
                        );
                      })}
                      <div className="timeline-footer d-flex justify-content-end text-muted small">
                        <span>By {history[0]?.updated_by}</span>&nbsp;&nbsp;|&nbsp;&nbsp;
                        <span><FaClock className="me-1" />{new Date(history[0]?.updated).toLocaleTimeString()}</span>
                      </div>
                    </div>
                  </div>
                );
              })

            )
            // return null; // Replace with a valid JSX element if needed
          })}
          {/* 
              {logs.map((log, idx) => (
                <div key={idx} className="timeline-item">
                  <div className="timeline-icon"><FaUser /></div>
                  <div className="timeline-content">
                    <Link to={{ pathname: `${paths.editPrescription}/${log.prescription_id}` }}>
                        <div className="timeline-title">{log.drug}</div>
                    </Link>
                    <div className="timeline-desc">{log.change}</div>
                    <div className="timeline-footer d-flex justify-content-between text-muted small">
                      <span>By {log.updatedBy}</span>
                      <span><FaClock className="me-1" />{log.time}</span>
                    </div>
                  </div>
                </div>
              ))} */}
        </div>
      ))) : (<Alert variant="info" className="text-center mt-3">No Data Found</Alert>)}
    </div>
  );
};

export default PatientHistory;
